'use strict';
angular.module('mandaeApp')
    .controller('HistoricoPedidoIncompletoCtrl', function ($scope) {
        // classe para animação da view
        $scope.pageClass = 'page-incompleto';

    });
